"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderSlider = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("swiper/react");
var HeaderSliderElement_1 = require("../headerSliderElement/HeaderSliderElement");
var modules_1 = require("swiper/modules");
var HeaderSlider_module_scss_1 = __importDefault(require("./HeaderSlider.module.scss"));
var HeaderSlider = function () {
    var _a = (0, react_1.useState)([]), activeBanner = _a[0], setActiveBanner = _a[1];
    var _b = (0, react_1.useState)(false), isLoaded = _b[0], setIsLoaded = _b[1];
    var _c = (0, react_1.useState)(window.innerWidth < 768), isMobile = _c[0], setIsMobile = _c[1];
    var applyBanners = function (data) {
        setActiveBanner(data);
        setIsLoaded(true);
    };
    var fetchBanners = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/banners"))];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    applyBanners(Array.isArray(data) ? data : []);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Ошибка при загрузке баннеров:', error_1);
                    setIsLoaded(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var win = window;
        if (Array.isArray(win.__PRELOADED_BANNERS__)) {
            applyBanners(win.__PRELOADED_BANNERS__);
            return;
        }
        if (win.__BANNERS_PRELOAD__) {
            win.__BANNERS_PRELOAD__
                .then(function (data) {
                if (Array.isArray(data)) {
                    applyBanners(data);
                }
                else {
                    fetchBanners();
                }
            })
                .catch(function () {
                fetchBanners();
            });
            return;
        }
        fetchBanners();
    }, []);
    (0, react_1.useEffect)(function () {
        var handleResize = function () { return setIsMobile(window.innerWidth < 768); };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return (react_1.default.createElement("section", { className: HeaderSlider_module_scss_1.default.header_slider_wrapper, "aria-busy": !isLoaded },
        react_1.default.createElement("div", { className: HeaderSlider_module_scss_1.default.banner_placeholder },
            !isLoaded && react_1.default.createElement("div", { className: HeaderSlider_module_scss_1.default.banner_loader, "aria-hidden": "true" }),
            isLoaded && activeBanner.length > 0 && (react_1.default.createElement(react_2.Swiper, { modules: [modules_1.Autoplay, modules_1.Pagination, modules_1.Navigation], slidesPerView: 1, autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                }, pagination: {
                    clickable: true,
                    type: 'progressbar',
                }, rewind: true, navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }, loop: activeBanner.length > 1, observer: true, observeParents: true }, activeBanner.map(function (banner, index) { return (react_1.default.createElement(react_2.SwiperSlide, { key: banner.id },
                react_1.default.createElement(HeaderSliderElement_1.HeaderSliderElement, { title: banner.main_text, descriptionStroke: [banner.second_text], linkPath: "/", priority: index === 0, imgPath: isMobile
                        ? banner.image_urls[1] || banner.image_urls[0]
                        : banner.image_urls[0] }))); }))),
            isLoaded && activeBanner.length === 0 && (react_1.default.createElement("div", { className: HeaderSlider_module_scss_1.default.banner_loader }, "\u0411\u0430\u043D\u043D\u0435\u0440\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B"))),
        react_1.default.createElement("div", { className: "swiper-button-next" }),
        react_1.default.createElement("div", { className: "swiper-button-prev" })));
};
exports.HeaderSlider = HeaderSlider;
